module.exports = "/packs/images/pages/gift_cards/gift-card-voucher~82e71ab957c1cfde5198614290471b13.png";